import React from 'react';

interface PptExtProps {
    width?: number;
    height?: number;
}

export const PptExt = ({ height = 26, width = 26 }: PptExtProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 26 26"
        fill="none"
    >
        <g clipPath="url(#clip0_5885_18271)">
            <path
                d="M23.3269 5.11064L18.4519 0.235638C18.376 0.160337 18.2859 0.100762 18.1869 0.0603282C18.0879 0.0198946 17.9819 -0.000601989 17.875 1.34596e-05H4.875C3.52879 1.34596e-05 2.4375 1.0913 2.4375 2.43751V23.5625C2.4375 24.9087 3.52879 26 4.875 26H21.125C22.4712 26 23.5625 24.9087 23.5625 23.5625V5.68751C23.5631 5.58058 23.5426 5.47458 23.5022 5.37559C23.4618 5.27659 23.4022 5.18656 23.3269 5.11064ZM21.9375 23.5625C21.9375 24.0113 21.5738 24.375 21.125 24.375H4.875C4.42625 24.375 4.0625 24.0113 4.0625 23.5625V2.43751C4.0625 1.98876 4.42625 1.62501 4.875 1.62501H17.0625V4.87501C17.0625 5.77247 17.79 6.50001 18.6875 6.50001H21.9375V23.5625Z"
                fill="#D7D7D7"
            />
            <path
                d="M20 21.1667C20 21.625 19.625 22 19.1667 22H0.833333C0.375 22 0 21.625 0 21.1667V12.8333C0 12.375 0.375 12 0.833333 12H19.1667C19.625 12 20 12.375 20 12.8333V21.1667Z"
                fill="#F15642"
            />
            <path
                d="M14.4462 19.4971H13.6224V15.1973H12.1595V14.5H15.9056V15.1973H14.4462V19.4971Z"
                fill="white"
            />
            <path
                d="M10.0591 14.5C10.7039 14.5 11.1745 14.6322 11.4707 14.8965C11.7669 15.1608 11.915 15.5311 11.915 16.0073C11.915 16.2238 11.8809 16.43 11.8125 16.626C11.7464 16.8197 11.637 16.9917 11.4844 17.1421C11.3317 17.2902 11.13 17.4076 10.8794 17.4941C10.631 17.5807 10.3245 17.624 9.95996 17.624H9.42676V19.4971H8.60645V14.5H10.0591ZM10.0044 15.1802H9.42676V16.9404H9.87451C10.132 16.9404 10.3507 16.9108 10.5308 16.8516C10.7108 16.79 10.8475 16.6932 10.9409 16.561C11.0343 16.4289 11.0811 16.2546 11.0811 16.0381C11.0811 15.7487 10.9933 15.5334 10.8179 15.3921C10.6447 15.2508 10.3735 15.1802 10.0044 15.1802Z"
                fill="white"
            />
            <path
                d="M5.95264 14.5C6.59749 14.5 7.06803 14.6322 7.36426 14.8965C7.66048 15.1608 7.80859 15.5311 7.80859 16.0073C7.80859 16.2238 7.77441 16.43 7.70605 16.626C7.63997 16.8197 7.5306 16.9917 7.37793 17.1421C7.22526 17.2902 7.0236 17.4076 6.77295 17.4941C6.52458 17.5807 6.2181 17.624 5.85352 17.624H5.32031V19.4971H4.5V14.5H5.95264ZM5.89795 15.1802H5.32031V16.9404H5.76807C6.02555 16.9404 6.2443 16.9108 6.42432 16.8516C6.60433 16.79 6.74105 16.6932 6.83447 16.561C6.9279 16.4289 6.97461 16.2546 6.97461 16.0381C6.97461 15.7487 6.88688 15.5334 6.71143 15.3921C6.53825 15.2508 6.26709 15.1802 5.89795 15.1802Z"
                fill="white"
            />
        </g>
        <defs>
            <clipPath id="clip0_5885_18271">
                <rect width="26" height="26" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
